import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type OdsBadgeType = "brand" | "positive" | "negative" | "warning" | "neutral" | "subtle";

const badgeBackgroundClass: Record<OdsBadgeType, string> = {
  brand: "bg-[var(--bg-primary-subtle)]",
  positive: "bg-[var(--bg-positive-subtle)]",
  negative: "bg-[var(--bg-negative-subtle)]",
  warning: "bg-[var(--bg-warning-subtle)]",
  neutral: "bg-[var(--bg-secondary)]",
  subtle: "bg-[var(--bg-secondary)]",
};

const badgeTextClass: Record<OdsBadgeType, string> = {
  brand: "text-[var(--fg-brand)]",
  positive: "text-[var(--fg-positive)]",
  negative: "text-[var(--fg-negative)]",
  warning: "text-[var(--fg-warning)]",
  neutral: "text-[var(--fg-base)]",
  subtle: "text-[var(--fg-secondary)]",
};

interface OdsBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  type?: OdsBadgeType;
}

export function OdsBadge({ children, className, type = "neutral", ...props }: OdsBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex h-[20px] items-center justify-center rounded-lg px-2 text-[12px] font-medium leading-[120%]",
        badgeBackgroundClass[type],
        className
      )}
      {...props}
    >
      <span className={badgeTextClass[type]}>{children}</span>
    </span>
  );
}
